import {useInjection} from "@dp-instant/ui";
import "./UserIdLabel.less";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";

/**
 *
 * @description  Component for displaying user id. It will be drawn only on yandex platform
 */

export const UserIdLabel = () => {
    const social: ISocial = useInjection(TypesSocial.model);

    return __SOCIAL__ === "ya" ? (
        <div className="user-id-label">{`user id: ${social.me.id}`}</div>
    ) : null;
};
